import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Divider
} from '@mui/material';
import { Email, GitHub, Twitter } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const Footer = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: 2
          }}
        >
          {/* Left side - App info */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" gutterBottom>
              Short Story Platform
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Share your stories with the world
            </Typography>
          </Box>

          {/* Center - Contact info (for non-authenticated users) */}
          {!isAuthenticated && (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Need help or have questions?
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                <Email fontSize="small" color="action" />
                <Link
                  href="mailto:support@chscw.club"
                  color="primary"
                  underline="hover"
                  sx={{ fontWeight: 500 }}
                >
                  support@chscw.club
                </Link>
              </Box>
            </Box>
          )}

          {/* Right side - Links */}
          {/* 
          <Box sx={{ textAlign: { xs: 'center', md: 'right' } }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Connect with us
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Link
                href="https://github.com"
                color="inherit"
                aria-label="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GitHub fontSize="small" />
              </Link>
              <Link
                href="https://twitter.com"
                color="inherit"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter fontSize="small" />
              </Link>
            </Box>
          </Box>
          */}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Bottom row */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Short Story Platform. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link
              href="/privacy"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
            {isAuthenticated && (
              <Link
                href="/support"
                color="primary"
                underline="hover"
                variant="body2"
                sx={{ fontWeight: 500 }}
              >
                Support
              </Link>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
